import {
  List,
  ListItem,
  ListItemIcon,
  Stack,
  Typography,
  Tooltip,
  Collapse,
  Box,
  Chip,
  ListItemSecondaryAction
} from '@mui/material';
import { MailOutlined, PhoneOutlined } from '@mui/icons-material';
import { GlobalOutlined, NumberOutlined } from '@ant-design/icons';
import { useTheme } from '@mui/material/styles';
import CopyTextIconButton from 'components/CopyTextIconButton';
import { Company, User } from 'graphql/types';
import AssetLogo from 'sections/AssetLogo';
import PhoneNoRenderer from 'utils/getFormattedNumbers';
import { ListItemText } from '@mui/material';
import { MerchantContactInfoList } from './MerchantContactInfoList';

interface UserProfileListProps {
  user: User | null;
  isHovered?: boolean;
}
export default function UserProfileList({ user, isHovered }: UserProfileListProps) {
  const emailArray = [
    ...(user?.email ? [user.email] : []),
    ...(Array.isArray(user?.company?.email) ? user.company.email : [])
  ];

  const phoneArray = [
    ...(user?.data?.bizPhone ? [user?.data?.bizPhone] : []),
    ...(Array.isArray(user?.company?.phone) ? user.company.phone : [])
  ];

  return (
    <Collapse
      in={isHovered}
      timeout={600}
      easing="cubic-bezier(0.4, 0, 0.2, 1)"
      unmountOnExit
    >
      <Box sx={{ overflow: 'visible' }}>
        <MerchantContactInfoList
          items={emailArray}
          label="Email"
          isCollapsed={true}
        />
        <MerchantContactInfoList
          items={phoneArray}
          label="Phone"
          isCollapsed={true}
          renderer={(val) => <PhoneNoRenderer value={val} />}
        />
      </Box>
    </Collapse>
  );
}
